import {
  patch_lifecycle_default
} from "../../chunk-G2QGH4BR.mjs";

// src/components/return/index-browser.ts
var metaKey = Symbol();
var indexKey = Symbol();
var lifecycleMethods = {
  onMount: resetIndex,
  onUpdate: resetIndex
};
function getReturn(component) {
  const meta = component[metaKey];
  const index = component[indexKey];
  let val;
  if (meta) {
    if (index === void 0) {
      meta.push(val = createReturn(component));
    } else {
      val = meta[component[indexKey]++];
    }
  } else {
    patch_lifecycle_default(component, lifecycleMethods);
    component[metaKey] = [val = createReturn(component)];
  }
  return val;
}
function resetIndex() {
  this[indexKey] = 0;
}
function createReturn(component) {
  let curValue;
  return function(newVal, write) {
    if (write) {
      if (curValue && (curValue.value !== newVal.value || curValue.valueChange !== newVal.valueChange)) {
        component.forceUpdate();
      }
      return curValue = newVal;
    }
    return curValue;
  };
}
export {
  getReturn as default
};
